export const reformatExportChartSetData = (chartSet) => {
  return {
    category: chartSet.category,
    default: false,
    name: chartSet.name,
    state: {
      ...chartSet.state,
      charts: chartSet.state.charts.map((chart) => {
        return {
          name: chart.name,
          category: chart.category,
          ...(chart?.local && { local: chart.local, preferenceId: chart.preferenceId })
        };
      })
    }
  };
};

export const reformatExportChartData = (chart) => {
  return {
    category: chart.category,
    default: false,
    name: chart.name,
    state: chart.state,
    ...(chart?.local && { local: chart.local, preferenceId: chart.preferenceId })
  };
};
